import { ASSETS_API_URL } from "config/api";
import { getApiErrorMessages } from "config/apiErrors";
import React, { useState } from "react";
import "./dashboard.scss";
import axios from "axios";
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { MARKET_FIELDS, buildMarketFormData, normalizeSymbolInput, validateMarketForm } from "./marketFields";

const AddMarket = () => {

  const history = useHistory();
  const [marketName, setMarketName] = useState("");
  const [marketBase, setMarketBase] = useState("");
  const [decimals, setDecimals] = useState("");
  const [dailyWithdrawLimit, setDailyWithdrawLimit] = useState("");
  const [essential, setEssential] = useState(false);
  const [listed, setListed] = useState(false);
  const [available, setAvailable] = useState(false);
  const [marketIcon, setMarketIcon] = useState(null);
  const [preview, setPreview] = useState(null);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const clearError = (key) => {
    setErrors((prevErrors) => (prevErrors[key] ? { ...prevErrors, [key]: undefined } : prevErrors));
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    switch (id) {
      case "marketName":
        setMarketName(value);
        clearError("marketName");
        break;
      case "marketBase":
        // The API only accepts lowercase letters and numbers.
        setMarketBase(normalizeSymbolInput(value));
        clearError("marketBase");
        break;
      case "decimals":
        setDecimals(value);
        clearError("decimals");
        break;
      case "dailyWithdrawLimit":
        setDailyWithdrawLimit(value);
        clearError("dailyWithdrawLimit");
        break;
      default:
        break;
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    clearError("marketIcon");

    if (file) {
      setMarketIcon(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async () => {
    if (submitting) return;

    const form = {
      name: marketName,
      symbol: marketBase,
      decimals,
      dailyWithdrawLimit,
      isEssential: essential,
      isListed: listed,
      isAvailable: available,
      icon: marketIcon,
    };

    const formErrors = validateMarketForm(form);
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      toast.error("Please fix the highlighted fields", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    setSubmitting(true);
    const tok = localStorage.getItem("accessTokenDash");
    axios({
      method: "POST",
      url: `${ASSETS_API_URL}/markets`,
      headers: {
        authorization: `Bearer ${tok}`
      },
      data: buildMarketFormData(form),
    })
      .then(function () {
        toast.success("Market Added Successfully", {
          position: "top-right",
          autoClose: 3000,
        });
        history.push("market");
      })
      .catch(function (error) {
        const messages = getApiErrorMessages(error);
        toast.error(
          <div>{messages.map((message, index) => <div key={index}>{message}</div>)}</div>,
          { position: "top-right", autoClose: 6000 }
        );
        setSubmitting(false);
      });
  };

  return (
    <>
      <img className='elipse img-fluid' src='/assets/main-assets/Ellipse.png' alt="ellipse" />
      <div className="content">
        <div className="tokenicon">
          <p className="para1">Market Icon</p>
          <div className="headparent">
            <div className='maininput'>
            <label htmlFor='upload'>
              <div className='wrapper'>

                  {preview ?
                    (
                      <img src={preview} alt="Market Icon Preview" className="preview shcvsdghvdhc" />
                    )
                    :
                    (
                      <svg xmlns="http://www.w3.org/2000/svg" width="46" height="47" viewBox="0 0 46 47" fill="none" className='cursorrrr'>
                        <path d="M17.2501 21.1042C14.3367 21.1042 11.9792 18.7467 11.9792 15.8333C11.9792 12.92 14.3367 10.5625 17.2501 10.5625C20.1634 10.5625 22.5209 12.92 22.5209 15.8333C22.5209 18.7467 20.1634 21.1042 17.2501 21.1042ZM17.2501 13.4375C15.9276 13.4375 14.8542 14.5108 14.8542 15.8333C14.8542 17.1558 15.9276 18.2292 17.2501 18.2292C18.5726 18.2292 19.6459 17.1558 19.6459 15.8333C19.6459 14.5108 18.5726 13.4375 17.2501 13.4375Z" fill="#232323" />
                        <path d="M28.7499 44.1041H17.2499C6.84242 44.1041 2.39575 39.6574 2.39575 29.2499V17.7499C2.39575 7.34242 6.84242 2.89575 17.2499 2.89575H24.9166C25.7024 2.89575 26.3541 3.54742 26.3541 4.33325C26.3541 5.11909 25.7024 5.77075 24.9166 5.77075H17.2499C8.41408 5.77075 5.27075 8.91408 5.27075 17.7499V29.2499C5.27075 38.0858 8.41408 41.2291 17.2499 41.2291H28.7499C37.5858 41.2291 40.7291 38.0858 40.7291 29.2499V19.6666C40.7291 18.8808 41.3808 18.2291 42.1666 18.2291C42.9524 18.2291 43.6041 18.8808 43.6041 19.6666V29.2499C43.6041 39.6574 39.1574 44.1041 28.7499 44.1041Z" fill="#232323" />
                        <path d="M40.7292 11.5208H30.1875C29.4017 11.5208 28.75 10.8691 28.75 10.0833C28.75 9.29742 29.4017 8.64575 30.1875 8.64575H40.7292C41.515 8.64575 42.1667 9.29742 42.1667 10.0833C42.1667 10.8691 41.515 11.5208 40.7292 11.5208Z" fill="#232323" />
                        <path d="M35.4583 16.7917C34.6724 16.7917 34.0208 16.14 34.0208 15.3542V4.8125C34.0208 4.02667 34.6724 3.375 35.4583 3.375C36.2441 3.375 36.8958 4.02667 36.8958 4.8125V15.3542C36.8958 16.14 36.2441 16.7917 35.4583 16.7917Z" fill="#232323" />
                        <path d="M5.11741 38.2582C4.65741 38.2582 4.19741 38.0282 3.92908 37.6257C3.48824 36.9741 3.66074 36.0732 4.31241 35.6324L13.7616 29.2882C15.8316 27.9082 18.6874 28.0616 20.5657 29.6524L21.1982 30.2082C22.1566 31.0324 23.7857 31.0324 24.7249 30.2082L32.6982 23.3657C34.7491 21.6216 37.9307 21.6216 39.9816 23.3657L43.1057 26.0491C43.6999 26.5666 43.7766 27.4674 43.2591 28.0807C42.7416 28.6749 41.8407 28.7516 41.2274 28.2341L38.1032 25.5507C37.1449 24.7266 35.5157 24.7266 34.5766 25.5507L26.6032 32.3932C24.5716 34.1374 21.3707 34.1374 19.3199 32.3932L18.6874 31.8374C17.8057 31.0899 16.3491 31.0132 15.3716 31.6841L5.94158 38.0282C5.67324 38.1816 5.38574 38.2582 5.11741 38.2582Z" fill="#232323" />
                      </svg>
                    )
                  }

                <p className='gray'>
                  Add Market Icon Image
                  <br></br>
                  Supports: JPG, JPEG, PNG
                </p>
                <input type='file' id='upload' accept="image/png, image/jpeg, image/jpg" className='d-none' onChange={handleImageChange} />
                {errors.marketIcon && <p className="error">{errors.marketIcon}</p>}
              </div>
              </label>
            </div>
          </div>
          <div className="mainparent2">
            <p className="inputtextttt">{MARKET_FIELDS.name.label}</p>
            <input type="text" placeholder={MARKET_FIELDS.name.placeholder} className="inputttclass" id="marketName" value={marketName} onChange={handleInputChange} />
            {errors.marketName && <p className="error">{errors.marketName}</p>}

            <p className="inputtextttt">{MARKET_FIELDS.symbol.label}</p>
            <input type="text" placeholder={MARKET_FIELDS.symbol.placeholder} className="inputttclass" id="marketBase" value={marketBase} onChange={handleInputChange} />
            {errors.marketBase
              ? <p className="error">{errors.marketBase}</p>
              : <p className="pairfieldhint">{MARKET_FIELDS.symbol.hint}</p>}

            <p className="inputtextttt">{MARKET_FIELDS.decimals.label}</p>
            <input type="text" inputMode="numeric" placeholder={MARKET_FIELDS.decimals.placeholder} className="inputttclass" id="decimals" value={decimals} onChange={handleInputChange} />
            {errors.decimals
              ? <p className="error">{errors.decimals}</p>
              : <p className="pairfieldhint">{MARKET_FIELDS.decimals.hint}</p>}

            <p className="inputtextttt">{MARKET_FIELDS.dailyWithdrawLimit.label}</p>
            <input type="text" inputMode="decimal" placeholder={MARKET_FIELDS.dailyWithdrawLimit.placeholder} className="inputttclass" id="dailyWithdrawLimit" value={dailyWithdrawLimit} onChange={handleInputChange} />
            {errors.dailyWithdrawLimit
              ? <p className="error">{errors.dailyWithdrawLimit}</p>
              : <p className="pairfieldhint">{MARKET_FIELDS.dailyWithdrawLimit.hint}</p>}

            <div className="listedhead">
              <p className="availtab">Essential</p>
              <label className="switch">
                <input type="checkbox" checked={essential} onChange={() => setEssential(!essential)} />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="listedhead">
              <p className="availtab">Listed</p>
              <label className="switch">
                <input type="checkbox" checked={listed} onChange={() => setListed(!listed)} />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="listedhead">
              <p className="availtab">Available</p>
              <label className="switch">
                <input type="checkbox" checked={available} onChange={() => setAvailable(!available)} />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="mainbuttdiv">
              <button className="buttt1 w-100" onClick={handleSubmit} disabled={submitting}>
                {submitting ? "Adding Market..." : "Add Market"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddMarket;
